import { CustomEventWithDetail, CustomEventWithoutDetail } from 'rune-ts';

import { BaseInputAttribute } from './types';

export class BaseInputInputEvent extends CustomEventWithoutDetail {}

export class BaseInputChangeEvent extends CustomEventWithoutDetail {}

export class BaseInputFocusEvent extends CustomEventWithoutDetail {}

export class BaseInputBlurEvent extends CustomEventWithoutDetail {}

export class BaseInputAttributeChangedEvent extends CustomEventWithDetail<BaseInputAttribute> {}
